import { cn } from '@/lib/cn';
import { Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type ClickableTableRowProps = {
  to?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  label?: string;
  extraActions?: React.ReactNode;
  showViewIcon?: boolean;
  active?: boolean;
};

export function ClickableTableRow({
  to,
  onClick,
  children,
  className,
  label = 'Ver detalhes',
  extraActions,
  showViewIcon = true,
  active = false,
}: ClickableTableRowProps) {
  const navigate = useNavigate();

  function go() {
    if (onClick) {
      onClick();
      return;
    }
    if (to) navigate(to);
  }

  return (
    <tr
      className={cn(
        'group cursor-pointer transition-colors hover:bg-manejai-cream/50 focus-visible:bg-manejai-cream/50 focus-visible:outline-none',
        active && 'bg-manejai-cream/60 hover:bg-manejai-cream/60',
        className,
      )}
      onClick={go}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go();
        }
      }}
      tabIndex={0}
      role="link"
      aria-label={label}
    >
      {children}
      {showViewIcon && (
        <td className="px-5 py-3 w-12 text-right">
          <Eye
            className="h-4 w-4 text-manejai-moss/50 group-hover:text-manejai-moss transition-colors ml-auto"
            aria-hidden
          />
        </td>
      )}
      {extraActions && (
        <td
          className="px-3 py-3 text-right whitespace-nowrap"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {extraActions}
        </td>
      )}
    </tr>
  );
}
